<!-- /* @author: Shichin C @team: Shichin C, Robert Jesuraj, Samaj Babu George, Varun B Nair, Jimmy Jose
    
    @last_modified: 2017-11-10
    @place: EY @project: CAART_Angular 
    @version: 2.0 
    @folderStructure: */ -->

<!-- <app-login></app-login> -->
<!-- <app-logout></app-logout> -->
<!-- <router-outlet></router-outlet> -->
<app-loader *ngIf="showLoader" message="Application is loading..."></app-loader>
<app-layout *ngIf="!showLoader"></app-layout>

<!-- <app-nouser *ngIf="UserCheck.UserExists == false"></app-nouser> -->